import React, { Component } from "react";
import { Container, Header, Icon, Label, Menu } from "semantic-ui-react";

class MessageSystemCard extends Component {
  render() {
    var messages = this.props.messages
      ? this.props.messages.filter(msg => msg.readind === 0)
      : null;
    var alerts = this.props.alerts
      ? this.props.alerts.filter(alt => alt.readind === 0)
      : null;
    return (
      <Container>
        <Header as="h3">
          <Icon name="bell outline" />
          Notifications
        </Header>
        <Menu compact>
          <Menu.Item as="a" onClick={() => this.props.showModal("alerts")}>
            <Icon name="attention" />New Alerts
            {alerts ? <Label floating>{alerts.length}</Label> : <div />}
          </Menu.Item>
          <Menu.Item onClick={() => this.props.showModal("messages")}>
            <Icon name="mail" />Messages
            {messages ? <Label floating>{messages.length}</Label> : <div />}
          </Menu.Item>
        </Menu>
      </Container>
    );
  }
}
export default MessageSystemCard;



// WEBPACK FOOTER //
// ./src/components/home-components/messagesystem.js